import {useQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../QueryKey'
import {getTraderMapDetail} from '../../../apis/tradermap_project/detail'

const useQueryTraderMapProjectDetail = (id: string) => {
    const {data, refetch, isLoading} = useQuery({
        queryKey: QueryCacheKeys.tradermap.getTraderMapProjectDetail(id),
        queryFn: async () => {
            const {data} = await getTraderMapDetail(id)
            return data
        },
        enabled: !!id,
        refetchOnWindowFocus: false,
    })

    return {data: data, refetch, isLoading}
}

export default useQueryTraderMapProjectDetail
